import { createContext, type RefObject } from 'react';

export const CategoricalBarChartOverlayRefContext = createContext<
  RefObject<HTMLDivElement | null> | undefined
>(undefined);
